import React from 'react';
import { CircularProgress, LinearProgress, Stack } from '@mui/material';

const LoaderComponent = (props) => {
  const { loaderType } = props;

  switch (loaderType) {
    case 'linear':
      return <LinearProgress />;
    case 'circular':
      return (
        <Stack alignItems="center">
          <CircularProgress />
        </Stack>
      );
    default:
      return <></>;
  }
};

export default LoaderComponent;
